"use strict";

exports.__esModule = true;
exports.default = regExpEscape;

/**
 * Escape all reserved character for regular expressions.
 * @param {string} str
 */
function regExpEscape(str) {
  return str.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
}